// Document ready
$(function () {

  // Smooth scroll when clicking .pageLink anchors
  $(".pageLink a").on("click", function () {
    const speed = 500;
    const href = $(this).attr("href");
    const target = $(href === "#" || href === "" ? "html" : href);
    const position = target.offset().top;

    $("html, body").animate(
      { scrollTop: position },
      speed,
      "swing"
    );

    return false;
  });

  // Sequential item animation
  const animateItemBoxes = function () {
    $(".itemBox_item").each(function (index) {
      setTimeout(function () {
        $(".itemBox_item").removeClass("itemBox_visible");
        $(".itemBox_item")
          .eq(index)
          .addClass("itemBox_visible");
      }, 1500 * index);
    });
  };

  // Run immediately + repeat every 7.5 seconds
  animateItemBoxes();
  setInterval(animateItemBoxes, 7500);

  // Add .anime when list items scroll into view
  $(window).on("load scroll", function () {
    $(".itemDetail > li").each(function () {
      const itemTop = $(this).offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (scrollTop > itemTop - windowHeight + windowHeight / 3) {
        $(this).addClass("anime");
      }
    });
  });
  // Slick sliders on load
  if ($.fn.slick) {
    $(".alldoll_mv").slick({
      autoplay: true,
      speed: 500,
      autoplaySpeed: 4000,
      dots: true,
      arrows: false,
      pauseOnHover: false,
      pauseOnFocus: false
    });

    $(".buyItem_slide").slick({
      autoplay: true,
      speed: 500,
      autoplaySpeed: 4000,
      dots: true,
      arrows: true,
      pauseOnHover: false,
      pauseOnFocus: false
    });
  }
});
